import { TipoProdutoEnum } from '../../../enums/produto/tipo-produto.enum';

/** Produto candidato à associação de um item da NF-e de entrada. */
export class ProdutoAssociacaoStruct {
  public idProduto: number = 0;
  public descricao: string = '';
  public codigoSku: string | null = null;
  public gtinEan: string | null = null;
  public ncm: string | null = null;
  public unidade: string | null = null;
  public idUnidadeMedida: number | null = null;
  public isControlaLotes: boolean = false;
  public isControlaSeries: boolean = false;
  public idTipoProduto: TipoProdutoEnum = TipoProdutoEnum.Simples;
  /** True quando este produto é o agrupador de uma variação; a associação exige indicar o SKU filho. */
  public isAgrupadorVariacao: boolean = false;
  public codigoNoFornecedor: string | null = null;
  public unidadeFornecedor: string | null = null;
  public fatorConversaoFornecedor: number | null = null;
  /** A unidade de estoque aceita quantidade fracionada; sem unidade cadastrada vale true. */
  public isUnidadeMedidaFracionada: boolean = true;
}
